import { render, staticRenderFns } from "./UserMultiSelect.component.vue?vue&type=template&id=ef654374&scoped=true&"
import script from "./UserMultiSelect.component.vue?vue&type=script&lang=js&"
export * from "./UserMultiSelect.component.vue?vue&type=script&lang=js&"
import style0 from "./UserMultiSelect.component.vue?vue&type=style&index=0&id=ef654374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef654374",
  null
  
)

export default component.exports